import { BellOff } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import "@/components/notifications-empty.css";

export function NotificationsEmpty({ title }: { title: string }) {
  const { t } = useI18n();
  return (
    <div className="notifications-empty">
      <span className="notifications-empty-icon">
        <BellOff size={20} aria-hidden="true" />
      </span>
      <p className="notifications-empty-title">{title}</p>
      <p className="notifications-empty-text">
        {t("notifications.empty.description")}
      </p>
    </div>
  );
}
